import { Dispatch, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import {
  CREATE_TIPO_USUARIO_REQUEST,
  CREATE_TIPO_USUARIO_SUCCESS,
  CREATE_TIPO_USUARIO_FAILURE,
  FETCH_TIPOS_USUARIOS_REQUEST,
  FETCH_TIPOS_USUARIOS_SUCCESS,
  FETCH_TIPOS_USUARIOS_FAILURE,
  FETCH_TIPO_USUARIO_REQUEST,
  FETCH_TIPO_USUARIO_SUCCESS,
  FETCH_TIPO_USUARIO_FAILURE,
  UPDATE_TIPO_USUARIO_REQUEST,
  UPDATE_TIPO_USUARIO_SUCCESS,
  UPDATE_TIPO_USUARIO_FAILURE,
  DELETE_TIPO_USUARIO_REQUEST,
  DELETE_TIPO_USUARIO_SUCCESS,
  DELETE_TIPO_USUARIO_FAILURE,
  SET_TIPOS_USUARIOS_PAGE,
  SET_TIPOS_USUARIOS_LIMIT
} from '../../../constants/tiposUsuarios/TiposUsuarios';
import { message } from 'antd';
import { RootState } from '../../store/store';
import fetchWithIP from '../utils/FechHeaders';

export interface TipoUsuarioDto {
  tipo_usuario: string;
  empresaId: number;
}
export const createTipoUsuarioRequest = () => ({
  type: CREATE_TIPO_USUARIO_REQUEST
});

export const createTipoUsuarioSuccess = (data: any) => ({
  type: CREATE_TIPO_USUARIO_SUCCESS,
  payload: data
});

export const createTipoUsuarioFailure = (error: string) => ({
  type: CREATE_TIPO_USUARIO_FAILURE,
  payload: error
});

export const fetchTiposUsuariosRequest = () => ({
  type: FETCH_TIPOS_USUARIOS_REQUEST
});

export const fetchTiposUsuariosSuccess = (data: any) => ({
  type: FETCH_TIPOS_USUARIOS_SUCCESS,
  payload: data
});

export const fetchTiposUsuariosFailure = (error: string) => ({
  type: FETCH_TIPOS_USUARIOS_FAILURE,
  payload: error
});

export const fetchTipoUsuarioRequest = () => ({
  type: FETCH_TIPO_USUARIO_REQUEST
});

export const fetchTipoUsuarioSuccess = (data: any) => ({
  type: FETCH_TIPO_USUARIO_SUCCESS,
  payload: data
});

export const fetchTipoUsuarioFailure = (error: string) => ({
  type: FETCH_TIPO_USUARIO_FAILURE,
  payload: error
});

export const updateTipoUsuarioRequest = () => ({
  type: UPDATE_TIPO_USUARIO_REQUEST
});

export const updateTipoUsuarioSuccess = (data: any) => ({
  type: UPDATE_TIPO_USUARIO_SUCCESS,
  payload: data
});

export const updateTipoUsuarioFailure = (error: string) => ({
  type: UPDATE_TIPO_USUARIO_FAILURE,
  payload: error
});

export const deleteTipoUsuarioRequest = () => ({
  type: DELETE_TIPO_USUARIO_REQUEST
});

export const deleteTipoUsuarioSuccess = (tipoUsuarioId: string) => ({
  type: DELETE_TIPO_USUARIO_SUCCESS,
  payload: tipoUsuarioId
});

export const deleteTipoUsuarioFailure = (error: string) => ({
  type: DELETE_TIPO_USUARIO_FAILURE,
  payload: error
});

export const setTiposUsuariosPage = (page: number) => ({
  type: SET_TIPOS_USUARIOS_PAGE,
  payload: page
});

export const setTiposUsuariosLimit = (limit: number) => ({
  type: SET_TIPOS_USUARIOS_LIMIT,
  payload: limit
});

export const createTipoUsuario = (
  tipoUsuarioData: TipoUsuarioDto
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(createTipoUsuarioRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        'tipos-usuarios',
        {
          method: 'POST',
        },
        tipoUsuarioData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al crear el tipo de usuario');
      }

      dispatch(createTipoUsuarioSuccess(data));
      message.success('Tipo de usuario creado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al crear el tipo de usuario';
      dispatch(createTipoUsuarioFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const fetchTiposUsuarios = (
  page: number = 1,
  limit: number = 10,
  empresaId?: number
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(fetchTiposUsuariosRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      let url = `tipos-usuarios?page=${page}&limit=${limit}`;
      if (empresaId) {
        url += `&empresaId=${empresaId}`;
      }

      const response = await fetchWithIP(
        url,
        {
          method: 'GET',
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al obtener los tipos de usuario');
      }

      dispatch(fetchTiposUsuariosSuccess(data));
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al obtener los tipos de usuario';
      dispatch(fetchTiposUsuariosFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const updateTipoUsuario = (
  id: string,
  tipoUsuarioData: TipoUsuarioDto
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(updateTipoUsuarioRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        `tipos-usuarios/${id}`,
        {
          method: 'PUT',
        },
        tipoUsuarioData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al actualizar el tipo de usuario');
      }

      dispatch(updateTipoUsuarioSuccess(data));
      message.success('Tipo de usuario actualizado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al actualizar el tipo de usuario';
      dispatch(updateTipoUsuarioFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const deleteTipoUsuario = (
  id: string
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(deleteTipoUsuarioRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(
        `tipos-usuarios/${id}`,
        {
          method: 'DELETE',
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al eliminar el tipo de usuario');
      }

      dispatch(deleteTipoUsuarioSuccess(id));
      message.success('Tipo de usuario eliminado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al eliminar el tipo de usuario';
      dispatch(deleteTipoUsuarioFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};